/* 
 * Enum for layout breakpoints. Represents the minimum width values for different layout sizes.
*/
export default class LayoutBreakpoint {  
  /*
   * Represents small screens with a minimum width of 380px and max 767px
   */
  static get Small() {
    return this.getInstance(380, `(max-width: 767px)`, "Small");
  }

  /*
   * Represents medium screens with a minimum width of 768px and max 1023px
  */
  static get Medium() {
    return this.getInstance(768,  `(min-width: 768px) and (max-width: 1023px)`, "Medium");
  }
    
  /*
   * Represents Big screens with a minimum width of 1024px
  */
  static get Big() {
    return this.getInstance(1024, `(min-width: 1024px)`, "Big");
  }

  static getInstance(key, mediaQuery, text) {
    if (!this.instances[key]) {
      this.instances[key] = new LayoutBreakpoint(key, mediaQuery, text);
    }

    return this.instances[key];
  }
  
  /*
   * Get the layoutBreakpoint by the media query
  */
  static getLayoutBreakpointByMediaQuery(mediaQuery){
    switch(mediaQuery){
      case LayoutBreakpoint.Small.getMediaQuery():
        return LayoutBreakpoint.Small;
      case LayoutBreakpoint.Medium.getMediaQuery():
        return LayoutBreakpoint.Medium;
      case LayoutBreakpoint.Big.getMediaQuery():
        return LayoutBreakpoint.Big;
      default:
        return LayoutBreakpoint.Small;
    }
  }

  /*
   * All LayoutBreakpoints values
  */
  static toList(){
    return [
      LayoutBreakpoint.Small,
      LayoutBreakpoint.Medium,
      LayoutBreakpoint.Big,
    ];
  }

  constructor(value, mediaQuery, text) {
    this.value = value;
    this.mediaQuery = mediaQuery;
    this.text = text;
  }
  
  toString() {
    return this.text;
  }

  getValue(){
    return this.value;
  }

  getMediaQuery(){
    return this.mediaQuery;
  }


}
  
Object.defineProperty(LayoutBreakpoint, 'instances', { value: {} });  